import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/messages');

export interface State {
  closed: boolean;
}

export const closeMessage = actionCreator('CLOSE');
